var _rect, _rect2, _rect3, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 42,
    viewBox: "0 0 48 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 48,
    height: 30,
    rx: 4,
    fill: "#E8EBF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 16,
    width: 40,
    height: 12,
    rx: 4,
    fill: "#FEFEFE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 32,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#FEFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.62134L8.06774 8.616C8.92192 8.47447 9.58804 7.79938 9.71812 6.94338L10.6213 1.00001L11.3215 6.87968C11.4271 7.76685 12.1084 8.47633 12.9905 8.61791L19.2426 9.62134L12.9869 10.6372C12.1065 10.7802 11.4272 11.4888 11.3215 12.3744L10.6213 18.2427L9.71804 12.3106C9.58795 11.4563 8.92382 10.7821 8.07151 10.6392L2 9.62134Z",
    fill: "#828AE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.68933L16.7772 3.39487C17.6314 3.25334 18.2975 2.57825 18.4276 1.72225L18.6893 -1.51829e-05L18.8869 1.65855C18.9925 2.54571 19.6737 3.2552 20.5559 3.39678L22.3787 3.68933L20.5522 3.98594C19.6719 4.1289 18.9926 4.83751 18.8869 5.72312L18.6893 7.37868L18.4275 5.65931C18.2974 4.80496 17.6333 4.1308 16.781 3.98791L15 3.68933Z",
    fill: "#828AE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateEmpty);
export default __webpack_public_path__ + "static/media/template-empty.1bc709c8ae7db1cd84f9f9dcb12fddbb.svg";
export { ForwardRef as ReactComponent };